import { fetchApi } from '@/config/axiosSetting';

export const likeEducationFunction = (data: { id: number }) => {
  return fetchApi.post('/education/like/', data);
};
